<template>
  <div
    class="tg-login"
    v-loading.fullscreen="loginLoading"
    element-loading-text="Loading"
    element-loading-spinner="tg-icon-loading"
    element-loading-custom-class="tg-loading--wrapper"
  >
    <div class="tg-login--container">
      <h1 class="tg-login--title">{{ title }}</h1>
      <div :class="formClass">
        <div class="field" :class="{ focus: focusName }">
          <el-input
            v-model="formData.username"
            :placeholder="$t('component.form.input.placeholder.username')"
            class="tg-input"
            @focus="focusName = true"
            @blur="focusName = false"
          ></el-input>
          <i class="tg-icon tg-icon-username" style="font-size: 1.6em"></i>
        </div>
        <div class="field" :class="{ focus: focusPwd }">
          <el-input
            v-model="formData.password"
            :placeholder="$t('column.password')"
            class="tg-input"
            type="password"
            @focus="focusPwd = true"
            @blur="focusPwd = false"
          >
            <i
              class="tg-icon tg-icon-help"
              slot="suffix"
              @click="goto('forgetPwd')"
            >
            </i>
          </el-input>
          <i class="tg-icon tg-icon-password" style="font-size: 1.6em"></i>
        </div>
        <el-row type="flex" justify="space-between" align="start">
          <tg-dropdown
            v-if="showLangSelector"
            :items="langList"
            @on-change="handleLangChange"
            trigger="click"
            placement="bottom"
            class="tg-login--lang col-4"
          ></tg-dropdown>
          <el-checkbox v-model="rememberMe" label="1">{{
            $t("component.label.rememberMe")
          }}</el-checkbox>
          <!-- <span v-if="$store.state.app.lang.message" class="as-link" @click="goto('forgetPwd')">{{
            $t("page.other.login.forgetPwd")
          }}</span> -->
        </el-row>
        <tg-button
          class="tg-login-btn col-12 ma-t-5"
          :class="{ active }"
          @click.native="handleSubmit"
          >{{ $t("component.btn.login") }}</tg-button
        >
      </div>
      <!-- 錯誤彈窗 -->
      <el-alert
        type="tg-alert"
        show-icon
        v-show="alert.show"
        :style="alert.style"
        @close="handleAlertClose"
      >
        {{ alert.message }}
        <template v-if="alert.type == 107">
          <!--
              用户名或密码错误第次 ，此帐号已冻结 ，请联络 客服人员 或 申请解锁
          -->
          ，{{ $t("page.other.login.alert.lockTip") }} <br />{{
            $t("page.other.login.alert.str[0]")
          }}
          <span class="text-primary clickable" @click="goto('service')">
            <i>{{ $t("page.other.login.alert.link[0]") }}</i>
          </span>
          {{ $t("page.other.login.alert.str[1]") }}
          <span class="text-primary clickable" @click="goto('restoreAccount')">
            <i>{{ $t("page.other.login.alert.link[1]") }}</i>
          </span>
        </template>
        <template v-else-if="alert.type != 108"
          >，{{ $t("page.other.login.alert.note") }}</template
        >
      </el-alert>
    </div>
    <tg-dialog
      theme="warning"
      :showIcon="!isServiceDialog"
      :title="serviceTitle"
      :visible.sync="showDialog"
      append-to-body
      top="35vh"
      width="20%"
      :showFooter="!isServiceDialog"
      :showCancelBtn="!isServiceDialog && alert.type == 107"
      :confirmLabel="confirmLabel"
      :cancelLabel="cancelLabel"
      @on-confirm="handleDialogConfirm"
      @on-cancel="handleDialogCancel"
    >
      <el-row type="flex" justify="center" align="middle">
        <template v-if="dialogType == 'service'">
          <span
            v-if="!iframe.src"
            style="text-align: center; font-size: 36px"
            class="text-red"
            v-html="$t('component.dialog.customer_service.fix')"
          >
          </span>
        </template>
        <template v-else>
          {{ alert.message }}
          <template v-if="alert.type == 107">
            <!--
              用户名或密码错误第次 ，此帐号已冻结
            -->
            ，{{ $t("page.other.login.alert.lockTip") }}
          </template>
          <template v-else-if="alert.errorCount && alert.type != 108">
            ，{{ $t("page.other.login.alert.note") }}
          </template>
        </template>
      </el-row>
    </tg-dialog>
    <tg-customer-service-dialog ref="serviceDialog" :src="iframe.src">
    </tg-customer-service-dialog>
    <span
      v-loading.fullscreen="showLoading"
      element-loading-text="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></span>
  </div>
</template>

<script>
import TgButton from "@/components/button/TgButton";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgDialog from "@/components/dialog/TgDialog";
import TgCustomerServiceDialog from "@/components/dialog/TgCustomerServiceDialog";
import Cookies from "js-cookie";

import apis from "@/apis";
import str from "@/utils/str";

export default {
  components: {
    TgButton,
    TgDropdown,
    TgDialog,
    TgCustomerServiceDialog,
  },
  data() {
    return {
      formData: {
        username: "",
        password: "",
      },
      focusName: false,
      focusPwd: false,
      active: false,
      loginLoading: false,
      alert: {
        type: 0,
        errorCount: 0,
      },
      dropdown: [
        {
          label: "简体中文",
          value: "zh-cn",
        },
        {
          label: "繁體中文",
          value: "zh-hk",
        },
      ],
      showDialog: false,
      dialogType: "",
      showLoading: false,
      iframe: {
        src: "",
      },
      loadedLang: false,
      rememberMe: false,
    };
  },
  computed: {
    title() {
      return this.$t("component.header.title");
    },
    showLangSelector() {
      return this.langList.length > 0; //process.env.VUE_APP_I18N == 1;
    },
    formClass() {
      return ["tg-login--form", this.$route.name];
    },
    serviceTitle() {
      if (this.dialogType == "service") {
        return this.$t("component.service.24h");
      }
      return this.$t("component.dialog.title");
    },
    confirmLabel() {
      if (this.alert.type == 107) {
        return this.$t("page.other.login.alert.link[1]");
      }
      return this.$t("component.btn.confirm");
    },
    cancelLabel() {
      return this.$t("page.other.login.alert.link[0]");
    },
    isServiceDialog() {
      return this.dialogType == "service";
    },
    activeLang() {
      return this.$store.state.app.lang.key;
    },
    langList() {
      let active = this.activeLang;

      return this.$store.state.app.langList.map((x) => {
        return {
          active: x.lang_code == active,
          label: x.lang_display,
          value: x.lang_code,
        };
      });
    },
  },
  created() {
    this.$store.dispatch("app/logout");
    this.$store.commit("breadcrumb/clear");
    this.$store.dispatch("app/fetchLang", { lang: this.formData.lang });

    let index = this.langList
      ? this.langList.findIndex((x) => x.active == true)
      : -1;
    this.formData.lang =
      index >= 0 ? this.langList[index].value : this.langList[0].value;

    let remember = Cookies.get("TG-AGENT-REMEMBER");

    if (this.$store.state.app.demo != null) {
      this.formData.username = this.$store.state.app.demo.username;
      this.formData.password = this.$store.state.app.demo.session;
    }

    if (remember && remember.length > 0) {
      this.rememberMe = true;
      let cache = Cookies.get("TG-AGENT-REMEMBER");

      if (cache) {
        let rememberData = JSON.parse(str.decrypt(cache));

        this.formData.username = rememberData.username;
        this.formData.password = rememberData.password;
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyUp);
    if (this.$route.params.pmode) {
      this.alert.message = this.$t("page.other.login.alert.pMode");
      this.$nextTick(() => {
        this.showDialog = true;
      });
    }
  },
  destroyed() {
    window.removeEventListener("keyup", this.handleKeyUp);
  },
  methods: {
    handleSubmit() {
      if (!this.active) {
        return;
      }
      this.active = false;
      this.$store.dispatch("app/stopCountdown");

      // 避免AJAX操作過程表單被調整
      let rememberMe = this.rememberMe;
      let rememberData = {
        username: this.formData.username,
        password: this.formData.password,
      };

      apis
        .login({ ...this.formData, rememberMe: rememberMe })
        .then((response) => {
          if (response.retcode > 0) {
            this.showFailedAlert(response);
            this.active = this.checkActive();
          } else {
            this.loginLoading = true;

            // 記住帳密
            if (rememberMe) {
              Cookies.set(
                "TG-AGENT-REMEMBER",
                str.encrypt(JSON.stringify(rememberData)),
                { expires: 36500 }
              );
            } else {
              Cookies.remove("TG-AGENT-REMEMBER");
            }

            if (this.formData.lang != this.$store.state.app.lang.key) {
              this.$store
                .dispatch("app/fetchLang", { lang: this.formData.lang })
                .then(() => {
                  this.$router.push({ name: "home" });
                });
            } else {
              this.$router.push({ name: "home" });
            }
          }
        });
    },
    handleKeyUp(e) {
      this.formData.username = this.formData.username.trim();
      if (this.formData.username && this.formData.password) {
        if (e.keyCode === 13) {
          this.handleSubmit();
        }
      }
    },
    checkActive() {
      this.$nextTick(() => {
        this.active =
          this.formData.username &&
          this.formData.password &&
          this.formData.password.length >= 6;
      });
    },
    handleAlertClose() {
      this.alert.show = false;
    },
    showFailedAlert(response) {
      // login failed
      this.alert.type = response.retcode;
      let errorCount = response.error_count;
      let message = "";

      switch (response.retcode) {
        case 108:
          message = this.$t("page.other.login.alert.disabled");
          break;

        case 115:
          message = this.$t("page.other.login.alert.ip_white_empty");
          break;

        case 116:
          message = this.$t("page.other.login.alert.ip_white_wrong", {
            ip: response.ip,
          });
          break;

        case 122:
          message = this.$t("page.other.login.alert.pMode");
          break;

        default:
          message = this.$t("page.other.login.alert.failed");
          break;
      }

      if (errorCount) {
        message += this.$t("page.other.login.alert.count", { errorCount });
      }

      this.alert.message = message;
      this.alert.errorCount = errorCount;
      this.dialogType = "alert";
      this.$nextTick(() => {
        this.showDialog = true;
      });
    },
    goto(name) {
      if (name == "service") {
        this.showLoading = true;
        apis.getCustomerServiceIframeUrl(this.$user).then((response) => {
          this.showLoading = false;
          this.iframe.src = response.data.url;
          this.showDialog = !response.data.url;

          if (response.data.url) {
            this.$nextTick(() => {
              this.$refs.serviceDialog.showDialog();
            });
          }
        });
      } else {
        this.$router.push({ name });
      }
    },
    handleLangChange(item) {
      this.formData.lang = item.value;
      this.$store.dispatch("app/fetchLang", { lang: item.value });
    },
    handleDialogConfirm() {
      if (this.alert.type == 107) {
        this.goto("restoreAccount");
      }
    },
    handleDialogCancel() {
      if (this.alert.type == 107) {
        this.dialogType = "service";
        this.$nextTick(() => {
          this.goto("service");
        });
      }
    },
  },
  watch: {
    "formData.username"() {
      this.checkActive();
    },
    "formData.password"() {
      this.checkActive();
    },
    langList(val) {
      let index = val ? val.findIndex((x) => x.active == true) : -1;
      this.formData.lang = index >= 0 ? val[index].value : val[0].value;
    },
  },
};
</script>
